import { render, staticRenderFns } from "./GeneralMeeting.vue?vue&type=template&id=b8ce3f60&scoped=true&"
import script from "./GeneralMeeting.vue?vue&type=script&lang=js&"
export * from "./GeneralMeeting.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMeeting.vue?vue&type=style&index=0&id=b8ce3f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce3f60",
  null
  
)

export default component.exports